import React from 'react';
import { FormControl, InputLabel, Input, withStyles } from '@material-ui/core';
import MaskedInput from 'react-text-mask';

const styles = theme => ({
  margin: {
    margin: theme.spacing.unit,
  },
  cssLabel: {
    '&$cssFocused': {
      color: '#0098DA',
    },
  },
  cssFocused: {},
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#0098DA',
    },
  },
});

function PhoneMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      guide={false}
    />
  );
}

function pickCustomInput(id) {
  switch (id) {
    case 'phone':
      return PhoneMaskCustom;
    default:
      return undefined;
  }
}

export default withStyles(styles)(props => {
  const { classes } = props;
  const today = new Date().toISOString().split('T')[0];

  return (
    <FormControl className={classes.margin}>
      <InputLabel
        {...props.InputLabelProps}
        FormLabelClasses={{
          root: classes.cssLabel,
          focused: classes.cssFocused,
        }}
        htmlFor={props.id}
      >
        {props.label}
      </InputLabel>
      <Input
        classes={{ underline: classes.cssUnderline, }}
        id={props.id}
        value={props.value}
        onChange={props.onChange}
        inputComponent={pickCustomInput(props.id)}
        inputProps={props.type === 'date' ? { min: today.toString() } : {}}
        autoComplete={'off'}
        onFocus={props.onFocus}
        onKeyUp={props.onKeyUp}
        onClick={props.onClick}
        onBlur={props.onBlur}
        type={props.type}
      />
    </FormControl>
  );
});
